'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.officialUrl = officialUrl;
exports.officialQBUrl = officialQBUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                              * @Author: edvardchen
                                                                                                                                                                                                                              * @Date:   2017-03-22 16:55:20
                                                                                                                                                                                                                              * @Last Modified by: jerryfwang
                                                                                                                                                                                                                              * @Last Modified time: 2020-09-23 12:05:49
                                                                                                                                                                                                                              */

/**
 * 有关订阅号地址拼接规则
 */

/**
 * 订阅号地址
 * @param  {String} options.id
 * @param  {String} options.ch
 * @param  {String} options.innerCh 内部渠道号
 * @param  {String} options.env     环境
 * @return {String}
 */
function officialUrl(_ref) {
  var id = _ref.id,
      ch = _ref.ch,
      innerCh = _ref.innerCh,
      env = _ref.env;

  var origin = env === 'test' ? 'http://tagtest.cs0309.html5.qq.com' : 'https://zixun.html5.qq.com';

  var params = {
    bzId: id,
    ch: ch,
    innerCh: innerCh
  };

  return origin + '/taglist/subscribe?' + _queryString2.default.stringify(params);
}

function officialQBUrl(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      ch = _ref2.ch,
      listurl = _ref2.listurl,
      rest = _objectWithoutProperties(_ref2, ['id', 'name', 'ch', 'listurl']);

  var params = {
    type: 0,
    ctype: 2,
    mtttitle: name,
    b_f: ch,
    listurl: listurl || officialUrl(_extends({ id: id, ch: ch }, rest))
  };

  // iOS 终端抽风，需要qb://ext/read?cid 来判断是否资讯框架
  // 谜一样的逻辑
  return 'qb://ext/read?cid=' + id + '&' + _queryString2.default.stringify(params);
}